<template>
  <v-card>
    <v-card-title>
      Kiosks
      <v-spacer></v-spacer>
      <v-select v-model="selectedTag" :items="tagsList" item-text="name" label="Tag selection"
        v-on:change="onChangeSelectTag" style="top: 0.7rem;"></v-select>
      <v-spacer>
      </v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details
        clearable></v-text-field>
    </v-card-title>
    <v-data-table fixed-header v-model="selected" :headers="headers" :items="kiosksTableData" item-key="name"
      class="elevation-1" :search="search" :custom-filter="customSearch">

      <template v-slot:[`item.selected`]="{ item }">
        <v-chip text-color="white">
          {{ item }}</v-chip>
      </template>
      <template style="pointer-events : none;" v-slot:[`item.lastCheck`]="{ item }" width="100%">
        <v-chip text-color="white" :color="getColor(item.lastCheck.lastCheck)" width="100%">
          {{ item.lastCheck.toPrint }}
        </v-chip>

      </template>

      <template v-slot:[`item.tags`]="{ item }">
        <v-chip class="ma-1 white--text" :style="{ background: tags[n.id].color }" v-for="(n, key) in item.tags"
          :key="key">
          {{ n.name }}
        </v-chip>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <td class="name-cell">
          <span class="clickable-name" @click="handleClick(item)" @mouseenter="maybeAddOnShift(item, $event)">{{ item.name }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on" @click.stop="handleButtonHistoryClick(item)"><v-icon small>mdi-history</v-icon></v-btn>
            </template>
            <span>Historique des versions</span>
          </v-tooltip>
        </td>
        <!--<td text-color="white" @click="handleClick(item)">{{ item.name }} </td>-->
      </template>

      <!-- <template v-slot:[`item.etat`]="{ item }"  >
    <v-chip   text-color="white" @click.stop="updateEtat(item)" :color="VerifyEtat(item)">{{ item.etat}}</v-chip>      
  </template> -->

      <template v-slot:[`item.isSelected`]="{ item }">
        <v-checkbox :input-value=item.isSelected @click="toggleSelection(item)" class="custom-checkbox"></v-checkbox>
      </template>
      <template v-slot:[`item.lastJob`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon :class="{ 'spin': LastJobColor[item.lastJob] === 'grey' }" :color="LastJobColor[item.lastJob]"
              v-on="on" :value="LastJobIcon[item.lastJob] || LastJobIcon['Default']">{{ LastJobIcon[item.lastJob] ||
                LastJobIcon['Default'] }}</v-icon>
          </template>
          <span>{{ item.lastJob || 'Loading' }}</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.state`]="{ item }">
        <v-chip :color="LastJobColor[item.state]" text-color="white">{{ item.state }}</v-chip>
      </template>

      <template v-slot:[`item.jobDtae`]="{ item }">
        <div>{{ item.jobDtae || 'Loading' }}</div>
      </template>

      <template v-slot:[`item.sleepActive`]="{ item }">
        <v-tooltip v-if="item.sleepActive === false" bottom>
          <template v-slot:activator="{ on }" v-if="item.sleepActive === false">
            <v-icon :color="LastJobColor['warning']" v-on="on">{{ LastJobIcon['warning'] }}</v-icon>
          </template>
          <span>The terminal has not been put on standby for over 48 hours</span>
        </v-tooltip>
      </template>



    </v-data-table>

    <v-dialog v-model="showHistory" max-width="600px">
  <v-card v-if="currentItem">
    <v-card-title>
      Historique des versions : {{ currentItem.name }}
    </v-card-title>

    <v-divider />

    <v-card-text>
      <!-- Ici on remplace les colonnes v-list par une simple table -->
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left">Version</th>
            <th class="text-left">Date</th>
            <th class="text-left">Fait par</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in dialogHistory" :key="item.id">
            <td>{{ item.version }}</td>
            <td>{{ item.date }}</td>
            <td>{{ item.user }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>

    <v-divider />

    <v-card-actions>
      <v-spacer />
      <v-btn text @click="showHistory = false">Fermer</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    <div>
      <!-- <DialogComponent :show="showDialog"  :item="objet" v-if="showDialog == true " @closeDialogConfirmation="closeDialogConfirmation()"></DialogComponent> -->
    
    </div>
  </v-card>
</template>
<script>


import { niceDateTimeFormat } from "@/utils/DateFormatter";
import { store } from "@/models/Store.js";
//import { getListLastJobs } from "@/services/RequestService";
//import  DialogComponent  from './DialogConfirmationComponent.vue';

export default {
  components: {  },
  async beforeCreate() {
    store.firstCallAndLaunchIntervals();
  },
  mounted() {

    // �couter un element'custom-event'
    this.$on('custom-event', () => {
      this.showDialog = false;
      // Mettre � jour les �l�ments de la liste afficher
      if (store.state.afficher.length !== 0) {
        this.selected = store.state.afficher;
        store.setAfficher([]);
      }


      // let list = []
      // for (const element of this.kiosksTableData) {
      //   list.push(element.name)
      // }
      // try {
      //   getListLastJobs(list).then((e) => {
      //     store.setJobs(e)
      //   })
      // }
      // catch (e) {
      //   console.log(e);
      // }
    });

    // Add listeners for Shift-hover highlighting
    window.addEventListener("keydown", this._onKeyDown);
    window.addEventListener("keyup", this._onKeyUp);
    const tableEl = this.$el && this.$el.querySelector('.v-data-table');
    if (tableEl) {
      tableEl.addEventListener('mousemove', this._onTableMouseMove);
      tableEl.addEventListener('mouseleave', this._clearShiftHover);
    }

  },

  beforeDestroy() {
    window.removeEventListener("keydown", this._onKeyDown);
    window.removeEventListener("keyup", this._onKeyUp);
    const tableEl = this.$el && this.$el.querySelector('.v-data-table');
    if (tableEl) {
      tableEl.removeEventListener('mousemove', this._onTableMouseMove);
      tableEl.removeEventListener('mouseleave', this._clearShiftHover);
    }
  },


  data() {
    return {
      // Object to define the color for each job status
      LastJobColor: {
        created: "orange",
        transmited: "green",
        done: "blue",
        abandonned: "red",
        AppUpdateJob: "primary",
        NoSleepJob: "primary",
        GetReportJob: "primary",
        GetDiagJob: "primary",
        GetSetParamJob: "primary",
        GetSetPropertiesJob: "primary",
        DebugJob: "primary",
        WeRepairJob: "primary",
        KillJavaJob: "primary",
        ResetNameJob: "primary ",
        null: "grey",
        SetOrGetParamJob: "primary ",
        'Not found': "black",
        warning: "orange"

      },        // lignes sélectionnées
      isShiftSelecting: false,
      // whether Shift is currently held (used for hover behavior)
      shiftPressed: false,
      // index of hovered row inside current tbody when Shift is held
      shiftHoveredRowIndex: null,
      objet: {},
      showDialog: false,
      sortDescending: true,
      afficher: [],
      store: store,
      showHistory: false,
      currentItem: null,
      dialogHistory : [
        { id: 1, version: 'TEST', date: '2026-01-15', user: 'Nuage' },
        { id: 2, version: 'TEST', date: '2025-12-10', user: 'Autres' },
        { id: 3, version: 'TEST', date: '2025-11-05', user: 'Nuage' },
        { id: 4, version: 'TEST', date: '2025-10-01', user: 'Nuage' }
      ],
      /**
       * The list of tags in the Tag selection field.
       */
      tagsList: store.tagsList,
      // currently selected tag in the Tag selection field
      selectedTag: '',
      search: "",
      /**
       * It's the trigger for activate 
       * computed => kiosksTableData when selecttag change
       */
      triggerTagChangement: 0,
      selected: [],
      headers: [
        { text: '', value: 'isSelected', sortable: true, },
        {
          text: "KioskExtranetId",
          align: "start",
          sortable: true,
          value: "idExtranet",
        },
        {
          text: "Kiosk",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Tags", value: "tags", align: "center" },
        // { text: "Installed", value: "etat", align: "center" },
        {
          text: "Status", value: "lastCheck", align: "center",
          sort: (a, b) => {

            let timeA = new Date(a.lastCheck).getTime();
            let timeB = new Date(b.lastCheck).getTime();
            if (a.lastCheck === undefined || b.lastCheck === undefined) {
              if (a.lastCheck === undefined && b.lastCheck === undefined) {
                return 0;
              } else if (a.lastCheck === undefined) {
                return -1;
              } else {
                return 1;
              }
            } else {
              let diff = timeA - timeB
              if (diff < 0) {
                return - 1
              } else if (diff > 0) {
                return 1;
              } else {
                return 0;
              }
            }
          }

        },
        //  { text: "mac", value: "macAddress" },
        { text: "softwareVersion", value: "softwareVersion", align: "center" },
        { text: "VPN", value: "vpnAddress", align: "center" },
        { text: "LastJob", value: "lastJob", align: "center", sortable: true },
        { text: "StateLastJob", value: "state", align: "center", sortable: true },
        {
          text: "DateLastJob", value: "jobDtae", align: "center", sortable: true, sort: function (a, b) {

            if (a === "Not found") {
              return this.sortDescending ? 1 : -1; // placer les cha�nes "not found" en dernier
            } else if (b === "Not found") {
              return this.sortDescending ? -1 : 1;
            } else {
              const regex = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})/;
              const aMatch = a.match(regex);
              const bMatch = b.match(regex);
              const aDate = new Date(
                aMatch[3],
                aMatch[2] - 1,
                aMatch[1],
                aMatch[4],
                aMatch[5],
                aMatch[6]
              );
              const bDate = new Date(
                bMatch[3],
                bMatch[2] - 1,
                bMatch[1],
                bMatch[4],
                bMatch[5],
                bMatch[6]
              );
              if (aDate > bDate) {
                return this.sortDescending ? -1 : 1;
              } else if (aDate < bDate) {
                return this.sortDescending ? 1 : -1;
              } else {
                return 0;
              }
            }
          }
        },
        { text: "Warning", value: "sleepActive", align: "center", sortable: true }

      ],
      kiosks: [],

    };
  },
  watch: {
    selected() {
      store.setSelectedKiosks(this.selected);
    },

  },
  methods: {

    // Add or remove item from selection when hovering the name while Shift is held
    maybeAddOnShift(item, event) {
      if (!(this.shiftPressed || (event && event.shiftKey))) {
        return;
      }

      const exists = this.selected.find((s) => s.name === item.name);
      if (exists) {
        // remove
        this.selected = this.selected.filter((s) => s.name !== item.name);
        store.setSelectedKiosks(this.selected);
      } else {
        // add
        this.selected.push(item);
        store.setSelectedKiosks(this.selected);
      }
    },

    // Handlers for Shift-hover highlighting
    _onKeyDown(e) {
      if (e.key === 'Shift') {
        this.shiftPressed = true;
      }
    },
    _onKeyUp(e) {
      if (e.key === 'Shift') {
        this.shiftPressed = false;
        this._clearShiftHover();
      }
    },
    _onTableMouseMove(event) {
      if (!this.shiftPressed) {
        this._clearShiftHover();
        return;
      }

      const tr = event.target.closest('tr');
      if (!tr || tr.parentElement.tagName !== 'TBODY') {
        this._clearShiftHover();
        return;
      }

      const rows = Array.from(tr.parentElement.children);
      const idx = rows.indexOf(tr);
      if (idx === -1) {
        this._clearShiftHover();
        return;
      }

      if (this.shiftHoveredRowIndex === idx) return;

      // remove previous
      if (this.shiftHoveredRowIndex !== null) {
        const prev = tr.parentElement.children[this.shiftHoveredRowIndex];
        if (prev) prev.classList.remove('nuage-shift-hover');
      }

      // add to current
      const newRow = rows[idx];
      if (newRow) newRow.classList.add('nuage-shift-hover');
      this.shiftHoveredRowIndex = idx;
    },
    _clearShiftHover() {
      const tableEl = this.$el && this.$el.querySelector('.v-data-table');
      if (!tableEl) return;
      const tbody = tableEl.querySelector('tbody');
      if (!tbody) return;
      if (this.shiftHoveredRowIndex !== null) {
        const prev = tbody.children[this.shiftHoveredRowIndex];
        if (prev) prev.classList.remove('nuage-shift-hover');
      }
      this.shiftHoveredRowIndex = null;
    },

    //chekbox
    toggleSelection(item) {
      //delete item if exist in Selcted
      const foundElement = this.selected.find((objet) => objet.name === item.name);
      if (foundElement) {
        this.selected = this.selected.filter((value) => {
          return value.name !== item.name;
        });
        store.setSelectedKiosks(this.selected);
      }
      //add item
      else {
        this.selected.push(item);
        store.setSelectedKiosks(this.selected);
      }
    },

    //click on the kiosk name 
    handleClick(item) {

      this.afficher = []
      //to keep the elements of my list selected after clicking on close => copy selected list 
      if (this.selected.length > 0) {
        for (var i in this.selected) {
          this.afficher.push(this.selected[i]);
        }
        store.setAfficher(this.afficher);
        this.selected = [];
        // set active row and deselect others
        store.setSelectedKiosks(this.selected)
      }
      this.selected.push(item);
      store.setSelectedKiosks(this.selected);
      this.chClick();
    },

    handleButtonHistoryClick(item) {
      this.currentItem = item
      this.showHistory = true
    },
    //Get Color Of buton yes / No
    // check if the machine is installed

    VerifyEtat(item) {
      let color = "green";
      if (item.etat === "no" || item.etat === "NO") {
        color = "red";
      }
      else {
        //initialize state 
        item.etat = "yes";
      }
      this.dialogVisible = true;
      return color;
    },
    //Open the dialogConfirmation
    async updateEtat(item) {
      if (this.showDialog == true) {
        this.showDialog = false;
      }
      this.objet = item;
      this.showDialog = true;
    },
    chClick() {
      //showBottomSheet
      this.$emit("sh");
    },
    /**
       * Increment a number for trigger computed
       * when we change the selectedTag
       */
    onChangeSelectTag() {
      this.triggerTagChangement += 1;
    },
    customSearch(value, search, item) {
      search = search.toLowerCase()
      // if value is Array
      if (Array.isArray(value)) {
        return value.some((it) =>
          Object.values(it).some(
            (v) => v && v.toString().toLowerCase().includes(search)
          )
        );
      }
      //else "classic object"
      return Object.values(item).some((v) => {
        if (v && v.toString().toLowerCase().includes(search)) {
          return true;
        } else if (
          v &&
          v.toPrint !== undefined &&
          v.toPrint.toString().toLowerCase().includes(search)
        ) {
          return true;
        } else {
          return false;
        }
      });
    },
    getColor(item) {
      if (item == undefined) {
        return "grey";
      }
      if (this.isDateMoreThanTwoDaysFromNow(item)) {
        return "red";
      } else if (this.isDateMoreThanOneDayFromNow(item)) {
        return "orange";
      } else {
        return "green";
      }
    },

    isDateMoreThanNdaysFromNow(inDate, nDays) {
      let dateInMillis = new Date(inDate).getTime();
      let now = Date.now();
      let oneDayInMillis = 24 * 60 * 60 * 1000;
      return now - dateInMillis > oneDayInMillis * nDays;
    },
    isDateMoreThanOneDayFromNow(inDate) {
      return this.isDateMoreThanNdaysFromNow(inDate, 1);
    },

    isDateMoreThanTwoDaysFromNow(inDate) {
      return this.isDateMoreThanNdaysFromNow(inDate, 2);
    },
    formatDate: function (date) {
      if (date === undefined) {
        return;
      } else {
        return niceDateTimeFormat(new Date(date));
      }
    },
    determineEndIndexToStudyWithNRollingDays(array, N) {
      let indToReturn = -1;
      for (let j = 0; j < array.length; j++) {
        if (this.isDateMoreThanNdaysFromNow(array[j].updatedAt, N)) {
          break;
        }
        indToReturn = j;
      }
      return indToReturn;
    },
    findJobByKioskName(name) {
      const jobs = this.store.state.jobs;
      if (jobs) {
        const job = jobs.find(job => job.kiosk === name)?.job;
        return job || null;
      }
      return null;
    },
    findAutoDiagJobByKioskName(date) {
      const twoDaysAgo = new Date();
      twoDaysAgo.setUTCDate(twoDaysAgo.getUTCDate() - 2); // Utiliser setUTCDate pour soustraire deux jours en UTC
      if (date != undefined) {
        const dateLastAutoDiagJob = new Date(date);
        return dateLastAutoDiagJob >= twoDaysAgo;
      }
      return false;
    }
  },
  computed: {

    /**
      * KiosksTableData receives and returns the 
      * kiosks list (with Object type) for display it 
      */
    kiosksTableData() {

      this.triggerTagChangement // Here for trigger computed when we change the selectedTag

      if (this.selectedTag == undefined || this.selectedTag == "") { // If there is a tag selected, we reduct the list of DISPLAYED kiosks, we don't change the request

        return this.store.state.listOfKiosks.map((e) => {
          //for the last Job :
          const state = e ? e.stateLastJob : "Not found";
          const jobDate = e ? this.formatDate(e.dateLastJob) : "Not found";
          const lastJob = e ? e.typeLastJob : "Not found";
          const autoDiagJob = this.findAutoDiagJobByKioskName(e.dateLastAutoDiagJob);
          const sleepActive = autoDiagJob;

          for (const element of this.selected) {
            if (element.name == e.name) {
              return {
                id: e._id,
                idExtranet: e.idExtranet,
                macAddr: e.macAddress,
                name: e.name,
                etat: e.etat,
                vpnAddress: e.vpnAddress,
                softwareVersion: e.softwareVersion,
                isSelected: true,
                lastCheck: {
                  lastCheck: e.lastCheck,
                  toPrint: this.formatDate(e.lastCheck),
                },
                //jobs:this.store.state.jobs.find(job => job.kiosk === e.name),
                state: state,
                jobDtae: jobDate,
                lastJob: lastJob,
                sleepActive: sleepActive,
                tags:
                  this.store.state.kiosksWithTags[e.idExtranet] !== undefined
                    ? store.state.kiosksWithTags[e.idExtranet].tags
                    : null,
              };
            }
          }

          return {
            id: e._id,
            idExtranet: e.idExtranet,
            macAddr: e.macAddress,
            name: e.name,
            etat: e.etat,
            vpnAddress: e.vpnAddress,
            softwareVersion: e.softwareVersion,
            isSelected: false,
            lastCheck: {
              lastCheck: e.lastCheck,
              toPrint: this.formatDate(e.lastCheck),
            },

            //jobs:this.store.state.jobs.find(job => job.kiosk === e.name),
            state: state,
            jobDtae: jobDate,
            lastJob: lastJob,
            //autoDiagJob: null,
            sleepActive: sleepActive,
            tags:
              this.store.state.kiosksWithTags[e.idExtranet] !== undefined
                ? store.state.kiosksWithTags[e.idExtranet].tags
                : null,

          };
        });
      } else {
        let tmpList = [];
        for (let current in this.store.state.listOfKiosks) {
          if (this.store.state.kiosksWithTags[this.store.state.listOfKiosks[current].idExtranet] != undefined && store.state.kiosksWithTags[this.store.state.listOfKiosks[current].idExtranet].tags.find(x => x.name == this.selectedTag) != undefined)
            tmpList.push(this.store.state.listOfKiosks[current]);
        }
        return tmpList.map((e) => {
          //for the lastJob
          const state = e ? e.stateLastJob : "Not found";
          const jobDate = e ? this.formatDate(e.dateLastJob) : "Not found";
          const lastJob = e ? e.typeLastJob : "Not found";
          const autoDiagJob = this.findAutoDiagJobByKioskName(e.dateLastAutoDiagJob);
          const sleepActive = autoDiagJob;
          //const updatedAt = autoDiagJob === true ? "The terminal has not been put on standby for over 48 hours":"Not found"  ;
          for (const element of this.selected) {
            if (element.name == e.name) {
              return {
                id: e._id,
                idExtranet: e.idExtranet,
                macAddr: e.macAddress,
                name: e.name,
                etat: e.etat,
                vpnAddress: e.vpnAddress,
                softwareVersion: e.softwareVersion,
                isSelected: true,
                lastCheck: {
                  lastCheck: e.lastCheck,
                  toPrint: this.formatDate(e.lastCheck),
                },
                tags: store.state.kiosksWithTags[e.idExtranet].tags,
                //jobs:this.store.state.jobs.find(job => job.kiosk === e.name),
                state: state,
                jobDtae: jobDate,
                sleepActive: sleepActive,
                lastJob: lastJob,
              };
            }
          }

          return {
            id: e._id,
            idExtranet: e.idExtranet,
            macAddr: e.macAddress,
            name: e.name,
            etat: e.etat,
            vpnAddress: e.vpnAddress,
            softwareVersion: e.softwareVersion,
            isSelected: false,
            lastCheck: {
              lastCheck: e.lastCheck,
              toPrint: this.formatDate(e.lastCheck),
            },
            tags: store.state.kiosksWithTags[e.idExtranet].tags,
            //jobs:this.store.state.jobs.find(job => job.kiosk === e.name),
            state: state,
            jobDtae: jobDate,
            lastJob: lastJob,
            sleepActive: sleepActive,
          };
        });
      }
    }


    ,
    tags() {
      return this.store.state.tags;
    },
    LastJobIcon() {
      return {
        AppUpdateJob: "mdi-cellphone-arrow-down",
        NoSleepJob: "mdi-alarm-snooze",
        GetReportJob: "mdi-book-open-variant",
        GetDiagJob: "mdi-home-analytics",
        GetSetParamJob: "mdi-table-cog",
        GetSetPropertiesJob: "mdi-bottle-tonic",
        DebugJob: "mdi-cloud-braces",
        WeRepairJob: "mdi-cloud-lock-outline",
        KillJavaJob: "mdi-language-java",
        ResetNameJob: "mdi-cog-counterclockwise ",
        Default: "mdi-cog",
        'Not found': "mdi-alert-octagon",
        SetOrGetParamJob: "mdi-table-cog",
        shutDown: "mdi-power",
        warning: "mdi-alert"
      }
    },


  },
};
</script>
<style>
.v-card-title.headline {
  text-align: center;
}

.v-card-actions.justify-center {
  justify-content: center;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.spin {
  animation: spin 1s linear infinite;
}

.clickable-name {
  cursor: pointer;
  color: #000;
  margin-right: 8px;
}

.name-cell {
  display: flex;
  align-items: center;
  gap: 14px;
}

.nuage-shift-hover {
  background-color: rgba(33, 150, 243, 0.12) !important;
}

</style>